export const DATA_HOOKS = {
    CONTENT_CONTAINER: 'content-container',
    DROPDOWN_LAYOUT_OPTIONS: 'dropdown-layout-options',
    INFINITE_SCROLL_CONTAINER: 'infinite-scroll-container',
    LINK_ITEM: 'link-item',
    TOP_ARROW: 'top-arrow',
    OPTION: 'dropdown-layout-option',
};
export const OPTION_DATA_HOOKS = {
    TITLE: 'dropdown-title',
    DIVIDER: 'dropdown-divider',
};
export const DATA_SHOWN = 'data-shown';
export const DATA_DIRECTION = 'data-direction';
export const DATA_SELECTED_OPTION_ID = 'data-selected-option-id';
export const DROPDOWN_LAYOUT_LOADER = 'dropdownLayout-loader';
export const DATA_OPTION = {
    SIZE: 'data-option-size',
    HOVERED: 'data-option-hovered',
    SELECTED: 'data-option-selected',
    DISABLED: 'data-option-disabled',
};
export const DROPDOWN_LAYOUT_DIRECTIONS = {
    UP: 'up',
    DOWN: 'down',
};
//# sourceMappingURL=DataAttr.js.map